import React from "react";
import { ClutterGraphGrid } from "./ClutterGrid";
import { observer } from "mobx-react-lite";
import { CourtCoverageOptionEnum } from "../../../../utils/data";
import { useMatchStatsStore } from "../../../../stores/StoreContext";

type props = {};

export const ClutterGrids: React.FC<props> = observer(() => {
  const matchStatsStore = useMatchStatsStore();
  let index = -1;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}>
      {Array.from({
        length:
          matchStatsStore.courtCoverageMap.get(
            matchStatsStore.selectedCourtCoverage
          )?.rows ?? 0,
      }).map((_, row) => (
        <div
          style={{
            display: "flex",
            flex: matchStatsStore.getCourtCoverageFrontBackFlex(row),
          }}>
          {Array.from({
            length:
              matchStatsStore.courtCoverageMap.get(
                matchStatsStore.selectedCourtCoverage
              )?.columns ?? 0,
          }).map((_, column) => {
            index++;
            return (
              <ClutterGraphGrid
                containerStyle={
                  matchStatsStore.selectedCourtCoverage ===
                  CourtCoverageOptionEnum.FRONT_BACK
                    ? {
                        justifyContent: "flex-end",
                        paddingRight: 20,
                      }
                    : matchStatsStore.selectedCourtCoverage ===
                      CourtCoverageOptionEnum.SIDES
                    ? { alignItems: "flex-end", paddingBottom: 20 }
                    : undefined
                }
                gridBgColor={`rgba(149, 68, 53,${
                  (matchStatsStore.courtCoverageMap.get(
                    matchStatsStore.selectedCourtCoverage
                  )?.zones[index].percentage ?? 0) / 100
                })`}
                scoreValue={`${Math.floor(
                  matchStatsStore.courtCoverageMap.get(
                    matchStatsStore.selectedCourtCoverage
                  )?.zones[index].percentage ?? 0
                )}%`}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
});
